"use client";

import { useQuery } from "@tanstack/react-query";

import { ensurePHPSESSIDCookie } from "../server/ensurePHPSESSIDCookie.function";

/**
 * Triggers the PHPSESSID sync as a one-shot client-side query. Running this
 * on the client (rather than in middleware) keeps SSR responses free of
 * per-user Set-Cookie writes, so the CDN can safely cache anonymous SSR
 * output without leaking session data across users.
 */
export function useEnsurePHPSESSIDCookie() {
  return useQuery({
    queryKey: ["ensurePHPSESSIDCookie"],
    queryFn: async () => ensurePHPSESSIDCookie(),
    staleTime: Infinity,
  });
}
